export default __webpack_public_path__ + "static/media/f_md-3.3b5f83f3.svg";